module.exports = __webpack_public_path__ + "images/automatic-scouts/setting_complete_en_1-c89fe3f01462dcc1e261d31aff409e0b.png";